import { PRIVATE_PAGE_ROUTES } from '@/enums';
import { UserData } from '@/types';

export const getPreviousRoute = (currentRoute: string) => {
  if (currentRoute.includes('/users/') || currentRoute.includes('/user/')) {
    return 'users';
  } else if (currentRoute.includes('/events/') || currentRoute.includes('/event/')) {
    return 'events';
  } else if (currentRoute.includes('/devices/') || currentRoute.includes('/device/')) {
    return 'devices';
  } else if (currentRoute.includes('/organizations/') || currentRoute.includes('/organization/')) {
    return 'organizations';
  } else if (currentRoute.includes('/themes/') || currentRoute.includes('/theme/')) {
    return 'themes';
  } else if (currentRoute.includes('/payment-plans/')) {
    return 'payment-plans';
  } else if (currentRoute.includes('/digital-signage/screens/')) {
    return 'digital-signage/screens';
  } else if (currentRoute.includes('/digital-signage/playlists/')) {
    return 'digital-signage/playlists';
  } else if (currentRoute.includes('/playlists/')) {
    return 'playlists';
  } else if (currentRoute.includes('/dashboard/')) {
    return 'dashboard';
  } else if (currentRoute.includes('/player-releases/')) {
    return 'player-releases';
  } else if (currentRoute.includes('/organization-assets/')) {
    return 'organization-assets';
  }
};

export const hasPreviousPage = (route: string) => {
  switch (route) {
    case '/users':
    case '/events':
    case '/devices':
    case '/organizations':
    case '/profile':
    case '/themes':
    case '/stock-clips':
    case '/payment-plans':
    case '/playlists':
    case '/organization-assets':
    case '/dashboard':
    case '/player-releases':
    case '/digital-signage/screens':
    case '/digital-signage/playlists':
    case '/ceremony-templates':
    case '/settings':
      return false;
    default:
      return true;
  }
};

const getDefaultCollectionRoute = <T extends { id: number | string }>(
  items: T[] | undefined,
  collectionRoute: string,
  singleItemRoute: (item: T) => string
) => {
  if (!items?.length) {
    return null;
  }

  if (items.length === 1) {
    return singleItemRoute(items[0]);
  }

  return collectionRoute;
};

const getEventRouteCandidate = (currentUserData: UserData | null) =>
  getDefaultCollectionRoute(
    currentUserData?.events,
    PRIVATE_PAGE_ROUTES.EVENTS,
    (event) => `${PRIVATE_PAGE_ROUTES.EVENTS}/${event.id}/upload-content/requests`
  );

const getDeviceRouteCandidate = (currentUserData: UserData | null) =>
  getDefaultCollectionRoute(
    currentUserData?.devices,
    PRIVATE_PAGE_ROUTES.DEVICES,
    (device) => `${PRIVATE_PAGE_ROUTES.DEVICES}/${device.id}`
  );

const getStoredHid = () => localStorage.getItem('hid');

export const getDefaultPrivateRoute = (currentUserData?: UserData | null) => {
  const hid = getStoredHid();

  if (hid) {
    return `${PRIVATE_PAGE_ROUTES.ADD_DEVICE}?hid=${hid}`;
  }

  return (
    getEventRouteCandidate(currentUserData ?? null) ??
    getDeviceRouteCandidate(currentUserData ?? null) ??
    PRIVATE_PAGE_ROUTES.EVENTS
  );
};
